module.exports = __webpack_public_path__ + "img/controlesimg5Propriedade.840c170c.svg";